<template>
  <el-aside class="h-full px-5 pt-5" width="290px">
    <div v-for="(type, index) in types" :key="index">
      <div class="mb-2 text-medium">
        <span class="text-black text-opacity-85 leading-base">{{ type.label }}</span>
        <template v-if="type.meta">
          <span v-if="type.meta.tips" class="ml-1">
            <el-tooltip>
              <span class="text-icon-default">
                <i :class="type.meta.icon || 'iconfont icon-shuoming text-theme-black-350 cursor-pointer'"></i>
              </span>
              <template v-slot:content>
                {{ type.meta.tips }}
              </template>
            </el-tooltip>
          </span>
          <template v-if="type.meta.isNewFeat">
            <span class="new-feature text-small ml-1">新功能</span>
          </template>
        </template>
      </div>
      <div class="grid grid-cols-2 gap-x-2 gap-y-2 mb-4">
        <div v-for="item in type.values" :key="item.value">
          <el-button
            data-drag="1"
            :data-type="item.value"
            :disabled="!isEdit"
            @click="onAdd(item)"
            class="el-button _edit_btn el-button--small rounded-small w-full text-left"
          >
            <span class="text-small mr-1.5"> <i :class="item.icon"></i> </span>{{ item.label }}
          </el-button>
        </div>
      </div>
    </div>
  </el-aside>
</template>

<script>
import { types } from './types'

export default {
  name: 'SampleAttrsAside',
  inject: ['isEdit'],
  data() {
    return {
      types: Object.freeze(types)
    }
  },
  methods: {
    onAdd(item) {
      this.$surveyBus.$emit('showDraft', true)
      this.$emit('add', item)
    }
  }
}
</script>
